import {Icon, TextSmallMedium, LabelSmallRegular, Pill} from '@hm/fundamental'
import {mdiCheck, mdiLockOpenOutline, mdiLockOutline} from '@mdi/js'
import {Divider} from '@mui/material'
import moment from 'moment'
import {useTranslation} from 'react-i18next'

import {ShutdownStatus} from '@refra/modules/common/enums'
import {Shutdown} from '@refra/modules/common/types'

interface ShutdownHistoryDetailProps {
  shutdown: Shutdown
  isSelected?: boolean
  onClick?: () => void
}

export const ShutdownHistoryDetail = ({
  shutdown,
  isSelected,
  onClick
}: ShutdownHistoryDetailProps) => {
  const {t} = useTranslation()
  const isDraftShutdown = shutdown.shutdownStatus === ShutdownStatus.Draft
  const formatDate = (date: string | undefined) => (date ? moment(date).format('DD.MM.YYYY') : '')

  return (
    <div
      data-cy="shutdown_history_shutdown_detail"
      className={`w-full pl-16px pr-16px sm:pl-24px sm:pr-24px hover:bg-container_background_selected cursor-pointer ${
        isSelected && 'bg-container_background_selected'
      }`}
      onClick={onClick && (() => onClick())}
    >
      <div className="flex justify-between">
        <div className="flex items-start gap-2 pb-3 pt-3">
          <div className="h-full pb-2 flex items-center" style={{color: 'var(--primary)'}}>
            <Icon
              size="regular"
              data-cy="shutdown_history_shutdown_detail_icon"
              path={isDraftShutdown ? mdiLockOpenOutline : mdiLockOutline}
            />
          </div>
          <div className="flex flex-col">
            <TextSmallMedium>{shutdown.name}</TextSmallMedium>
            <LabelSmallRegular>{`${formatDate(shutdown.interventionDate)} - ${formatDate(
              shutdown.feedingDate
            )}`}</LabelSmallRegular>
          </div>
        </div>
        <div className="pb-2 pr-2 flex items-center gap-4" style={{color: 'var(--positive)'}}>
          <Pill
            type="neutral"
            variant="shade"
            shape="rounded"
            size="regular"
            text={t(`refraPlanning.kilnShutdown.${shutdown.shutdownType}`)}
          />
          {isSelected && <Icon path={mdiCheck} />}
        </div>
      </div>
      <Divider />
    </div>
  )
}
